/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Highestprice1Inputs */

const he_item_stats_highestprice1 = /** @type {(inputs: Item_Stats_Highestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחיר הגבוה ביותר`)
};

const en_item_stats_highestprice1 = /** @type {(inputs: Item_Stats_Highestprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest ever`)
};

/**
* | output |
* | --- |
* | "Highest ever" |
*
* @param {Item_Stats_Highestprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_highestprice1 = /** @type {((inputs?: Item_Stats_Highestprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Highestprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_highestprice1(inputs)
	return en_item_stats_highestprice1(inputs)
});
export { item_stats_highestprice1 as "item_stats_highestPrice" }